import React from "react";
import { FaSearch, FaRedo } from "react-icons/fa";
import { termOptions } from "../../utils/helper";
import Select from "../../components/Select/Select";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import ExamHeaderSelect from "../ExamConfiguration/ExamHeaderSelect";

const ExamFilter = (props) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-4">
          <Select
            label={"Class"}
            name={"program_id"}
            value={props.program_id}
            placeholder={"Select Class"}
            onChangeHandler={props.onChangeHandler}
            options={props.programData}
          />
        </div>
        <div className="col-md-4">
          <Select
            label={"Subject"}
            name={"subject_id"}
            value={props.subject_id}
            placeholder={"Select Subject"}
            onChangeHandler={props.onChangeHandler}
            options={props.subjectData}
          />
        </div>
        <div className="col-md-4">
          <ExamHeaderSelect
            label="Exam Headers"
            name="name"
            placeholder={"Select Exam Headers"}
            value={props.name}
            onChangeHandler={props.onChangeHandler}
            examList={props.examList}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <Select
            label="Evaluation"
            name="evaluation_type_id"
            placeholder={"Select Evaluation Type"}
            value={props.evaluation_type_id}
            onChangeHandler={props.onChangeHandler}
            options={props.evaluationType}
          />
        </div>
        <div className="col-md-4">
          <Input
            label="From"
            type="date"
            name="start"
            value={props.start}
            onChangeHandler={props.onChangeHandler}
          />
        </div>
        <div className="col-md-4">
          <Input
            label="To"
            type="date"
            name="end"
            value={props.end}
            onChangeHandler={props.onChangeHandler}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <Select
            label="Status"
            name="status"
            placeholder={"Select Status"}
            value={props.status}
            onChangeHandler={props.onChangeHandler}
            options={props.statusData}
          />
        </div>
        <div className="col-md-4">
          <Select
            label="Term"
            name="term"
            placeholder={"Select Term"}
            value={props.term}
            onChangeHandler={props.onChangeHandler}
            options={termOptions}
          />
        </div>
        <div className="col-md-4">
          <label className="mb-1 mt-1 d-block invisible">Action</label>
          <div className="filter-actions">
            <Button
              variant="primary"
              type="submit"
              className="flex-fill"
              onClick={() => props.handleSearch({ selected: 0 })}
            >
              <FaSearch /> Search
            </Button>
            <Button
              variant="secondary"
              className="flex-fill"
              onClick={(event) => props.handleReset(event)}
            >
              <FaRedo /> Reset
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExamFilter;
